import ApexCharts from 'apexcharts';
import OrganizationModal from "../organization/organizationModel.vue";

export default {
  name: "home",
  components: {
    OrganizationModal,
  },
  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      idToken: localStorage.getItem("idToken"),
      therapeuticAreas: [
        {
          name: 'Oncology',
          percentage: 34,
          color: '#2563eb'
        },
        {
          name: 'Cardiology',
          percentage: 18,
          color: '#0cb8a8'
        },
        {
          name: 'Neurology',
          percentage: 15,
          color: '#5b5bff'
        },
        {
          name: 'Immunology',
          percentage: 13,
          color: '#9333ea'
        },
        {
          name: 'Infectious Diseases',
          percentage: 11,
          color: '#00d4ff'
        },
        {
          name: 'Rare Diseases',
          percentage: 9,
          color: '#f59e0b'
        }
      ],
      recentActivity: [
        {
          id: 1,
          initials: 'PN',
          avatarClass: 'av-purple',
          text: '<strong>Novotech</strong> added as a new CRO partner',
          tag: 'CRO',
          tagClass: 'tag-cro',
          person: 'Priya N.',
          time: '12m ago'
        },
        {
          id: 2,
          initials: '',
          avatarClass: 'av-teal av-icon',
          text: 'Study assignment <strong>ONC-4471</strong> completed for IQVIA',
          tag: 'Study',
          tagClass: 'tag-study',
          person: 'System',
          time: '48m ago'
        },
        {
          id: 3,
          initials: 'DK',
          avatarClass: 'av-dark',
          text: 'Contract <strong>SOW-2025-218</strong> approved & countersigned',
          tag: 'Contract',
          tagClass: 'tag-contract',
          person: 'Daniel K.',
          time: '2h ago'
        },
        {
          id: 4,
          initials: 'AM',
          avatarClass: 'av-green',
          text: 'GCP compliance review completed for <strong>Parexel</strong>',
          tag: 'Compliance',
          tagClass: 'tag-compliance',
          person: 'Aisha M.',
          time: '5h ago'
        },
        {
          id: 5,
          initials: 'PN',
          avatarClass: 'av-purple',
          text: 'New sponsor <strong>BioNexa Therapeutics</strong> onboarded',
          tag: 'Sponsor',
          tagClass: 'tag-sponsor',
          person: 'Priya N.',
          time: 'Yesterday'
        }
      ]
    }
  },
  mounted() {
    this.initializeCharts();
  },
  beforeUnmount() {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  },
   methods: {
    openNewOrganization() {
      this.$refs.orgModal.openOrganizationModal();
    },

    /**
     * Initialize charts - only Studies by Phase now
     */
    initializeCharts() {
      this.createStudiesByPhaseChart();
    },

    /**
     * Create Studies by Phase - Vertical Bar Chart
     * Shows study phases (I, II, III, IV) with their counts
     */
    createStudiesByPhaseChart() {
      if (this.chart) {
        this.chart.destroy();
      }

      const element = document.querySelector("#studiesByPhaseChart");
      if (element) {
        element.innerHTML = "";
      }
      console.log(element)

      const options = {
        chart: {
          type: 'bar',
          height: 300,
          toolbar: {
            show: false
          },
          sparkline: {
            enabled: false
          }
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            borderRadius: 6,
            distributed: true,
            dataLabels: {
              position: 'top'
            }
          }
        },
        dataLabels: {
          enabled: false
        },
        legend: {
          show: false
        },
        stroke: {
          show: true,
          width: 0,
          colors: ['transparent']
        },
        series: [{
          name: 'Studies',
          data: [55, 105, 115, 40]  // Phase I, II, III, IV
        }],
        colors: ['#00d4ff', '#5b5bff', '#2563eb', '#0cb8a8'],
        xaxis: {
          categories: ['Phase I', 'Phase II', 'Phase III', 'Phase IV'],
          labels: {
            style: {
              colors: '#9ca3af',
              fontSize: '12px',
              fontFamily: 'inherit'
            }
          }
        },
        yaxis: {
          title: {
            text: undefined
          },
          labels: {
            style: {
              colors: '#9ca3af',
              fontSize: '12px'
            }
          }
        },
        grid: {
          borderColor: '#f3f4f6',
          strokeDashArray: 0,
          yaxis: {
            lines: {
              show: true
            }
          }
        },
        tooltip: {
          theme: 'light',
          y: {
            formatter: function (val) {
              return val + " studies"
            }
          }
        }
      }

      if (element) {
        this.chart = new ApexCharts(element, options);
        this.chart.render();
      }
    },

    /**
     * Optional: Update chart data dynamically
     * Usage: this.updatePhaseChartData([60, 110, 120, 50])
     */
    updatePhaseChartData(newData) {
      ApexCharts.exec('studiesByPhaseChart', 'updateSeries', [{
        data: newData
      }]);
    },

    /**
     * Optional: Export chart as image
     */
    exportPhaseChart() {
      const chart = ApexCharts.getChartByID('studiesByPhaseChart');
      if (chart) {
        chart.download();
      }
    }
  }
}